import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import WeatherDataComponent from "./components/weather/WeatherData";

type WeatherDataProps = {
  apiUrl: string;
};

const WeatherData = ({ apiUrl }: WeatherDataProps) => (
  <div id="dacom-online">
    <Provider store={store}>
      <WeatherDataComponent apiUrl={apiUrl} />
    </Provider>
  </div>
);

export default WeatherData;
